import { Button, Paper, styled } from '@mui/material';

export const StyledGoalsCreateStepsPaper = styled(Paper)({
	paddingBottom: '24px',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	flexDirection: 'column',
	borderRadius: '16px',
	gap: '16px',
});

export const StyledGoalsCreateStepsImg = styled('img')({
	maxWidth: '100%',
	width: '100%',
	borderRadius: '16px',
	height: '260px',
	objectFit: 'cover',
	pointerEvents: 'none',
	marginTop: '-1px',
});

export const StyledGoalsCreateButton = styled(Button)(() => ({
	alignSelf: 'center',
	borderRadius: '12px',
	padding: '6px 24px',
	fontWeight: 600,
	letterSpacing: '0.15px',

	width: '100%',
}));
